import {
  Activity,
  Book,
  Briefcase,
  Car,
  Coffee,
  Film,
  Gamepad2,
  Globe,
  GraduationCap,
  Heart,
  Home,
  Megaphone,
  Music,
  Plane,
  ShoppingBag,
  Smartphone,
  Sparkles,
  Star,
  Target,
  TrendingUp,
  Tv,
  Users,
  Utensils,
  Wallet,
  Wifi,
} from "lucide-react";

const ICON_MAP = {
  activity: Activity,
  book: Book,
  briefcase: Briefcase,
  car: Car,
  coffee: Coffee,
  film: Film,
  game: Gamepad2,
  gamepad: Gamepad2,
  globe: Globe,
  graduation: GraduationCap,
  heart: Heart,
  home: Home,
  megaphone: Megaphone,
  music: Music,
  phone: Smartphone,
  plane: Plane,
  shopping: ShoppingBag,
  smartphone: Smartphone,
  sparkles: Sparkles,
  star: Star,
  target: Target,
  trending: TrendingUp,
  tv: Tv,
  users: Users,
  utensils: Utensils,
  wallet: Wallet,
  wellness: Heart,
  wifi: Wifi,
};

export const DEFAULT_AUDIENCE_ICON = Users;
export const DEFAULT_CAMPAIGN_ICON = Megaphone;

// TODO(icon-shim): delete `parseItemIcon` (and the ICON_MAP aliases above)
// when, on BOTH campaigns and segments:
//   SELECT count(*) WHERE icon IS NULL = 0
//   SELECT count(*) WHERE name LIKE ':%' = 0
// Observability: legacy uses surface as `[icon-shim]` console.warn in
// `getRowIcon.js`.
export function parseItemIcon(name, fallbackIcon) {
  const trimmed = (name ?? "").trim();
  if (trimmed.startsWith(":")) {
    const space = trimmed.indexOf(" ");
    const rawKey = space > 0 ? trimmed.slice(1, space) : trimmed.slice(1);
    const iconKey = rawKey.toLowerCase().trim();
    const displayName = space > 0 ? trimmed.slice(space + 1).trim() : "";
    return {
      Icon: ICON_MAP[iconKey] ?? fallbackIcon,
      displayName,
    };
  }
  return { Icon: fallbackIcon, displayName: trimmed };
}

export function nameOr(displayName, fallback) {
  return displayName && displayName.length > 0 ? displayName : fallback;
}
